// Affichage multi-fuseaux. Les heures des créneaux sont TOUJOURS exprimées
// dans le fuseau du tenant (le commerçant) : `slot.label` est calculé côté API
// dans ce fuseau, et `slot.start` est un instant absolu (ISO avec décalage).
// Ce module ne sert qu'à *traduire* cet instant à l'heure locale du visiteur,
// à titre informatif — il ne change jamais ce qui est réservé.

const _formatterCache = {};

/** Fuseau IANA du navigateur du visiteur (ex. « Europe/Paris »), ou null. */
export function getViewerTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  } catch (_error) {
    return null;
  }
}

/** Formate un instant ISO en « HH:MM » dans un fuseau donné, ou null si échec. */
export function formatTimeInZone(iso, timeZone, locale = "fr-FR") {
  if (!iso || !timeZone) {
    return null;
  }

  const key = `${locale}|${timeZone}`;
  let formatter = _formatterCache[key];
  if (!formatter) {
    try {
      formatter = new Intl.DateTimeFormat(locale, {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
        timeZone
      });
    } catch (_error) {
      return null;
    }
    _formatterCache[key] = formatter;
  }

  try {
    const date = new Date(iso);
    return Number.isNaN(date.getTime()) ? null : formatter.format(date);
  } catch (_error) {
    return null;
  }
}

/** Ville lisible d'un fuseau IANA : « America/Guadeloupe » → « Guadeloupe ». */
export function zoneCity(timeZone) {
  if (!timeZone) {
    return timeZone;
  }
  const part = timeZone.split("/").pop() || timeZone;
  return part.replace(/_/g, " ");
}

/** Date locale (« YYYY-MM-DD ») d'un instant ISO dans un fuseau donné. */
export function slotLocalDate(iso, timeZone) {
  if (!iso || !timeZone) {
    return null;
  }
  try {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) {
      return null;
    }
    // en-CA → format ISO « YYYY-MM-DD ».
    return new Intl.DateTimeFormat("en-CA", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      timeZone
    }).format(date);
  } catch (_error) {
    return null;
  }
}

/** Fuseau d'affichage effectif : sélection visiteur > fuseau navigateur > tenant. */
export function displayTimezone(state, config) {
  return (
    (state && state.selectedTimezone) ||
    (config && config.viewerTimezone) ||
    (config && config.timezone) ||
    null
  );
}

// Repli si Intl.supportedValuesOf n'existe pas (très vieux navigateurs).
const FALLBACK_ZONES = [
  "America/Guadeloupe", "America/Martinique", "America/Cayenne", "America/New_York",
  "America/Los_Angeles", "Europe/Paris", "Europe/London", "Europe/Warsaw",
  "Africa/Dakar", "Indian/Reunion", "Asia/Dubai", "Asia/Tokyo", "Australia/Sydney", "UTC"
];

/** Liste des fuseaux IANA pour le sélecteur (complète si dispo, sinon repli). */
export function listTimeZones() {
  try {
    if (typeof Intl.supportedValuesOf === "function") {
      const zones = Intl.supportedValuesOf("timeZone");
      if (Array.isArray(zones) && zones.length) {
        return zones;
      }
    }
  } catch (_error) {
    // repli ci-dessous
  }
  return FALLBACK_ZONES;
}
